// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kfNT","footer":"styles_footer__3jEkv","passCodeTooltip":"styles_passCodeTooltip__10kcZ"};